import api from './api';

export const followService = {
  follow: async (followingId) => {
    const res = await api.post('/Follow/Follow', { followingId });
    return res.data.data;
  },

  unfollow: async (followingId) => {
    const res = await api.delete(`/Follow/Unfollow/${followingId}`);
    return res.data.data;
  },

  isFollowing: async (followingId) => {
    const res = await api.get(`/Follow/IsFollowing/${followingId}`);
    return res.data.data;
  },
};
